import { ReactComponent as WarningIcon } from "../../assets/icons/warning_yellow.svg";
import warningStyles from "../../styles/UI/warning.module.css";
import labels from "../../utils/labels";

const WarningBox = ({
  violations, // not used
}: {
  violations: Record<string, string>[];
}) => {
  return (
    <div className={warningStyles.warningBox}>
      <WarningIcon width={14} height={14} />
      <div className="flex gap-[var(--spacing-xs)]">
        <p className={warningStyles.warningBoxTitle}>Information</p>
        <p className={warningStyles.warningBoxText}>
          {labels.noTransportCalculated}
        </p>
      </div>
    </div>
  );
};

export default WarningBox;
